(function(){
  'use strict';

  var raf = 0;

  function isMobile(){
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  function addStyles(){
    if (document.getElementById('erectus-whatsapp-float-guard')) return;
    var style = document.createElement('style');
    style.id = 'erectus-whatsapp-float-guard';
    style.textContent = [
      '.wa-float{display:flex!important;visibility:visible!important;opacity:1!important;position:fixed!important;z-index:2147483000!important;}',
      '@media (max-width:767px){.wa-float{right:12px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function visibleBottomBarHeight(){
    if (!isMobile()) return 0;
    var bar = document.querySelector('.js_sticky_atc_wrapper.sticky_atc_wrapper');
    if (!bar) return 0;
    var cs = window.getComputedStyle(bar);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity || '1') === 0) return 0;
    var rect = bar.getBoundingClientRect();
    if (rect.height <= 0) return 0;
    var nearBottom = rect.bottom >= window.innerHeight - 4 && rect.top < window.innerHeight;
    if (!nearBottom) return 0;
    return Math.ceil(rect.height);
  }

  function position(){
    addStyles();
    var wa = document.getElementById('waFloatBtn');
    if (!wa) return;
    if (wa.parentElement !== document.body) document.body.appendChild(wa);
    wa.removeAttribute('hidden');
    wa.setAttribute('aria-hidden','false');
    wa.style.setProperty('display','flex','important');
    wa.style.setProperty('visibility','visible','important');
    wa.style.setProperty('opacity','1','important');
    wa.style.setProperty('position','fixed','important');
    wa.style.setProperty('z-index','2147483000','important');
    wa.style.setProperty('right', isMobile() ? '12px' : '16px','important');
    var bottom = isMobile() ? 12 : 20;
    var stickyHeight = visibleBottomBarHeight();
    if (stickyHeight) bottom += stickyHeight;
    wa.style.setProperty('bottom', bottom + 'px','important');
  }

  function schedule(){
    if (raf) return;
    raf = window.requestAnimationFrame(function(){
      raf = 0;
      position();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', position);
  } else {
    position();
  }

  window.addEventListener('resize', schedule, {passive:true});
  window.addEventListener('scroll', schedule, {passive:true});
  document.addEventListener('shopify:section:load', schedule);
  window.setTimeout(position, 300);
  window.setTimeout(position, 1200);
})();
